import React, { ReactElement } from 'react'
import { ListProps } from 'react-admin'
import KList from 'ui-shared/KWrappers/KList'
import { KExporter } from 'services/csv/exporter'
import ReorderableListContent from './ReorderableListContent'

type Props = Omit<ListProps, 'exporter'> & {
  children: ReactElement
  exporter?: KExporter | boolean
}

const ReorderableList: React.FC<Props> = ({
  children,
  exporter = undefined,
  ...props
}) => {
  return (
    <KList {...props}>
      <ReorderableListContent>{children}</ReorderableListContent>
    </KList>
  )
}

export default ReorderableList
